<!-- Sidebar -->
<div class="sidebar w-14 flex flex-col flex-shrink-0 bg-neutral-50 dark:bg-neutral-800">
  <!-- Header -->
  <div
    class="border-b flex-shrink-0 h-16 flex items-center justify-center border-neutral-700/30"
    [class]="isAiAgentRoute ? 'bg-neutral-800' : 'bg-transparent'"
    routerLink="/"
  >
    <div
      class="w-14 h-15 mt-1 rounded-lg flex items-center justify-center transition-all duration-300"
    >
      <!-- w-10 h-10 bg-gradient-to-br from-primary-400 via-primary-500 to-primary-600 shadow-lg hover:shadow-xl -->
      <img src="/assets/demis-logo-white.png" [attr.alt]="'navbar.logoAlt' | transloco" style="width: 36px; height: auto" />
      <!-- <i class="pi pi-building text-white text-xl"></i> -->
    </div>
  </div>

  <!-- Navigation Menu -->
  <nav class="flex-1 p-2 space-y-3 overflow-y-auto justify-center">
    @for (item of navItems; track $index) {
      <div class="relative flex items-center justify-center">
        <button
          [disabled]="item.disable"
          (click)="!item.disable && navigateToRoute(item.route)"
          class="flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-200 relative"
          [pTooltip]="
            item.route === 'messenger' && shouldShowMessengerBadge
              ? getMessengerTooltip()
              : (item.labelKey | transloco)
          "
          [tooltipOptions]="
            item.route === 'messenger'
              ? {
                  tooltipStyleClass: 'messenger-tooltip',
                  escape: false,
                }
              : {}
          "
          [ngClass]="
            item.disable
              ? '!cursor-default opacity-50 text-neutral-500'
              : activeMenuItem.includes(item.route)
                ? 'cursor-pointer bg-primary-500/90 text-white dark:bg-primary-600'
                : 'cursor-pointer text-neutral-600 hover:bg-neutral-200 dark:text-neutral-300 dark:hover:bg-neutral-700'
          "
        >
          <i
            [class]="
              item.iconClass +
              '  ' +
              (activeMenuItem.includes(item.route)
                ? 'text-white'
                : 'text-neutral-600 dark:text-neutral-300')
            "
          ></i> 
          <!-- Badge for messenger item (desktop only) -->
          @if (item.route === 'messenger' && shouldShowMessengerBadge) {
            <span
              class="messenger-badge absolute -top-1 -right-1 min-w-[18px] h-[18px] flex items-center justify-center rounded-full text-[10px] font-semibold px-1 bg-rose-600 text-white"
            >
              {{ messengerUnreadMessages > 99 ? '99+' : messengerUnreadMessages }}
            </span>
          }
          <!-- <span
            class="text-xs text-center leading-tight"
            [ngClass]="
              activeMenuItem.includes(item.route)
                ? (isDark ? 'text-primary-200' : 'text-neutral-100')
                : (isDark ? 'text-neutral-300' : 'text-neutral-700')
            "
            >{{ item.labelKey | transloco }}</span
          > -->
        </button>
      </div>
    }

    <!-- Apps Section -->
    <div class="relative">
      <button
        #appsTrigger
        (click)="openAppsDialog()"
        class="w-10 h-10 flex items-center justify-center rounded-lg transition-all duration-200 cursor-pointer text-neutral-600 hover:bg-neutral-200 dark:text-neutral-300 dark:hover:bg-neutral-700"
        pTooltip="{{ 'navbar.apps' | transloco }}"
      >
        <i class="pi pi-th-large"></i>
      </button>
    </div>
  </nav>

  <!-- User Avatar and Theme Toggle -->
  <div class="p-2 flex-shrink-0 space-y-2">
    <!-- Theme Toggle -->
    <div class="relative flex justify-center">
      <button
        (click)="toggleTheme()"
        class="w-8 h-8 flex items-center justify-center rounded-lg transition-all duration-200 cursor-pointer text-neutral-600 bg-neutral-200 hover:bg-neutral-300 dark:text-neutral-300 dark:bg-neutral-700 dark:hover:bg-neutral-600"
        [attr.aria-label]="
          isDark
            ? ('header.theme.switchToLight' | transloco)
            : ('header.theme.switchToDark' | transloco)
        "
      >
        @if (isDark) {
          <i class="pi pi-sun text-amber-300"></i>
        } @else {
          <i class="pi pi-moon text-neutral-600"></i>
        }
      </button>
    </div>

    <!-- User Avatar -->
    <div class="relative flex justify-center">
      <button
        #userTrigger
        (click)="toggleUserPopover($event)"
        class="w-8 h-8 flex items-center justify-center rounded-lg transition-all duration-200 cursor-pointer text-neutral-600 bg-neutral-200 hover:bg-neutral-300 dark:text-neutral-300 dark:bg-neutral-700 dark:hover:bg-neutral-600"
      >
        <p-avatar
          [image]="currentUser?.picture"
          [label]="
            currentUser.picture ? null : currentUser?.username?.charAt(0)?.toUpperCase() || 'U'
          "
          size="normal"
          class="user-avatar-navbar w-full h-full rounded-lg avatar-image"
        >
        </p-avatar>
      </button>

      <p-popover #userPopover styleClass="topbar-user-popover">
        <app-user-popover
          [currentUser]="currentUser"
          [currentUserBalance]="currentUserBalance"
          [balanceLoading]="balanceLoading"
          [isDark]="isDark"
          [currentLanguage]="currentLanguage"
          [availableLanguages]="availableLanguages"
          [appVersion]="appVersion"
          [userPopoverRef]="userPopover"
          (logoutClick)="onLogoutClick()"
          (languageSelect)="onLanguageSelect($event)"
        ></app-user-popover>
      </p-popover>
    </div>
  </div>
</div>
